
import { ArticleData } from "@/data/articles/types";
import { articles } from "@/data/articles";
import { loadArticleContent } from "./articleLoader";

/**
 * Get article by slug asynchronously with content loading
 */
export const getArticleBySlug = async (slug: string): Promise<ArticleData | undefined> => {
  const article = articles.find(article => article.slug === slug);
  
  if (!article) {
    console.error(`Article not found with slug: ${slug}`);
    return undefined;
  }
  
  // Create a copy of the article to avoid modifying the original
  const articleCopy = { ...article };
  
  // Try to load the content if it doesn't exist
  if (!articleCopy.content) {
    articleCopy.content = await loadArticleContent(articleCopy);
  }
  
  // Debug to verify content is loaded
  if (articleCopy.content) {
    console.log(`Article ${slug} content loaded, length: ${articleCopy.content.length}`);
  } else {
    console.error(`Article ${slug} has NO CONTENT after loading attempt`);
  }
  
  return articleCopy;
};

/**
 * Get article by slug synchronously (without content loading)
 */
export const getArticleBySlugSync = (slug: string): ArticleData | undefined => {
  const article = articles.find(article => article.slug === slug);
  console.log("Inside getArticleBySlugSync ", articles)
  if (!article) {
    console.error(`Article not found with slug (sync): ${slug}`);
  } else {
    console.log(`Found article with slug (sync): ${slug}, contentPath: ${article.contentPath || 'inline content'}`);
  }
  return article;
};
